import { createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { showApiErrors } from '@/utils';
import { getLLMConfig, updateLLMConfig } from './actionCreators';
import { LLMConfigState, SLICE_NAME, initialState } from './models';

export const llmConfigSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLLMConfig.fulfilled, (state: LLMConfigState, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.llmConfig = payload;
      })
      .addCase(updateLLMConfig.fulfilled, (state: LLMConfigState, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.llmConfig = payload;
      })
      .addMatcher(isPending(getLLMConfig, updateLLMConfig), (state: LLMConfigState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(isRejected(getLLMConfig, updateLLMConfig), (state: LLMConfigState, action) => {
        const { error } = action;
        state.isLoading = false;
        state.error = error;
        showApiErrors(error);
      });
  },
});
